import { connect } from 'react-redux';

import {
  getFulfillmentMethod,
  getFulfillmentMethods,
  getHasMultipleFulfillmentMethods,
} from '../../selectors/homeSelectors';
import { setHomeFulfillmentMethod } from '../../actions/homeFeedActions';
import { trackToggledDeliveryType } from '../../actions/tracking/filters';

import HomeFiltersFulfillmentControl from './HomeFiltersFulfillmentControl';

const mapStateToProps = (state) => ({
  selectedMethod: getFulfillmentMethod(state),
  availableMethods: getFulfillmentMethods(state),
  showFulfillmentSwitchControl: getHasMultipleFulfillmentMethods(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (fulfillmentMethod) =>
    Promise.all([
      dispatch(trackToggledDeliveryType(fulfillmentMethod, 'restaurant list')),
      dispatch(setHomeFulfillmentMethod({ fulfillmentMethod })),
    ]),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeFiltersFulfillmentControl);
